import type { ServerListParams } from '@crm/shared';
import { createCrudThunks } from '../../store/createCrudThunks';
import { personApi } from './personApi';
import type { Person, PersonCreatePayload, PersonUpdatePayload } from './personTypes';

/**
 * Fetch-all: pageSize alto per caricare l'intero set di contatti del gruppo in
 * una request, quando serve un ordinamento/raggruppamento client-side non
 * esprimibile server-side (es. "gruppo del box Dashboard in cima"). Il backend
 * materializza già tutto in memoria (QueryUtil.ALL_POS + subList), quindi non
 * introduce costi DB aggiuntivi rispetto alla paginazione server.
 */
export const FETCH_ALL_PAGE_SIZE = 10000;

const thunks = createCrudThunks<Person, PersonCreatePayload, PersonUpdatePayload, ServerListParams>(
  'persons',
  personApi,
);

export const personThunks = thunks;
export const {
  fetchAll: fetchPersons,
  fetchOne: fetchPerson,
  create: createPerson,
  update: updatePerson,
  remove: deletePerson,
} = thunks;
